import wordIcon from './word-0.png'
import wordIcon1 from './word-1.png'
import wordIcon2 from './word-2.png'

import wordIcon3 from './word-0-2.png'
import wordIcon4 from './word-1-2.png'
import wordIcon5 from './word-2-2.png'

export default function getIcons(geoMode) {
  if (geoMode === 'inner') {
    return {
      wordIcon,
      wordIcon1,
      wordIcon2,
    }
  }
  return {
    wordIcon: wordIcon3,
    wordIcon1: wordIcon4,
    wordIcon2: wordIcon5,
  }
}
